
export class ProgramClaimsNav {
  public static item = {
    title: 'program.tab.claims',
    url: 'claims',
    icon: '<img src="./assets/icons/line-icons/nav/grey/claims.svg" width="23px" height="23px">',
    testId: 'prog-nav-claims',
  };
}
